{
  "page_count": "מתוך {n, plural, one{# דף} other{# דפים}}"
}
